export default __webpack_public_path__ + "static/media/8-sgi-documentos-v2.png:Zone.0543b9e3.Identifier";